import React, { type MutableRefObject, useEffect } from "react";
import FullscreenCarouselSlider from "./FullscreenCarouselSlider";
import { useUscSelector } from "../../../../../redux/store";
import * as Styles from "./FullscreenCarousel.styles";
import NavigationSlider from "../NavigationSlider";
import type { CarouselImageType } from "../../../../../utils/types";
import Button from "../../../../../../shared-components/lexus/styles/atoms/Button";
import Icon from "../../../../../../shared-components/lexus/styles/atoms/Icon";
import { useUscLabel } from "../../../../../utils/labels";
import { getHeaderImageAltTag } from "../../../../../utils/pdpUtils";

type FullscreenCarouselType = {
    images: CarouselImageType[];
    sharedSliderIndex: number;
    isFullscreen: boolean;
    scrollEnabled: MutableRefObject<boolean>;
    onClose: () => void;
    updateSharedSliderIndex: (index: number) => void;
};

const FullscreenCarousel = (props: FullscreenCarouselType): JSX.Element | null => {
    const { images, sharedSliderIndex, isFullscreen, scrollEnabled, onClose, updateSharedSliderIndex } = props;

    const result = useUscSelector((state) => state.vehicle.result);
    const dealer = useUscSelector((state) => state.dealer.dealer);

    const altTag = getHeaderImageAltTag(result, dealer);

    const closeFullscreenCarousel = (event: { key: string }): void => {
        const { key } = event;
        if (key === "Escape") {
            document.removeEventListener("keydown", closeFullscreenCarousel);
            onClose();
        }
    };

    useEffect(() => {
        document.addEventListener("keydown", closeFullscreenCarousel);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onClose]);

    const ariaCloseLabel = useUscLabel("uscA11yButtonClose");

    return (
        <>
            <Styles.Wrapper show={isFullscreen}>
                {isFullscreen && (
                    <Styles.CloseFullScreen>
                        <Button variant="control-slider" onClick={onClose} aria-label={ariaCloseLabel}>
                            <Icon variant="close" />
                        </Button>
                    </Styles.CloseFullScreen>
                )}

                {images.length > 0 && isFullscreen && (
                    <>
                        <FullscreenCarouselSlider
                            images={images}
                            altTag={altTag}
                            scrollEnabled={scrollEnabled}
                            updateSharedSliderIndex={updateSharedSliderIndex}
                        />
                        <NavigationSlider
                            images={images}
                            showArrowButtons
                            sharedSliderIndex={sharedSliderIndex}
                            updateSharedSliderIndex={updateSharedSliderIndex}
                            disableScroll={() => {
                                scrollEnabled.current = false;
                            }}
                        />
                    </>
                )}
            </Styles.Wrapper>
            <Styles.Backdrop hidden={!isFullscreen} />
        </>
    );
};
export default FullscreenCarousel;
